import { render, staticRenderFns } from "./module-update-card.vue?vue&type=template&id=7599d602&scoped=true"
import script from "./module-update-card.vue?vue&type=script&lang=ts"
export * from "./module-update-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7599d602",
  null
  
)

export default component.exports